var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_9584_24092)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9584_24092)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 40,
    height: 40,
    rx: 10,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 40,
    height: 40,
    rx: 10,
    fill: "url(#paint0_radial_9584_24092)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28 31.25H18C14.35 31.25 12.25 29.15 12.25 25.5V18.5C12.25 14.85 14.35 12.75 18 12.75H28C31.65 12.75 33.75 14.85 33.75 18.5V25.5C33.75 29.15 31.65 31.25 28 31.25ZM18 14.25C15.14 14.25 13.75 15.64 13.75 18.5V25.5C13.75 28.36 15.14 29.75 18 29.75H28C30.86 29.75 32.25 28.36 32.25 25.5V18.5C32.25 15.64 30.86 14.25 28 14.25H18Z",
    fill: "#F8F8FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9998 22.87C22.1598 22.87 21.3098 22.61 20.6598 22.08L17.5298 19.58C17.2098 19.32 17.1498 18.85 17.4098 18.53C17.6698 18.21 18.1398 18.15 18.4598 18.41L21.5898 20.91C22.3498 21.52 23.6398 21.52 24.3998 20.91L27.5298 18.41C27.8498 18.15 28.3298 18.2 28.5798 18.53C28.8398 18.85 28.7898 19.33 28.4598 19.58L25.3298 22.08C24.6898 22.61 23.8398 22.87 22.9998 22.87Z",
    fill: "#F8F8FC"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_9584_24092",
    x: 0,
    y: 0,
    width: 44,
    height: 44,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 2,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_9584_24092"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.172549 0 0 0 0 0.172549 0 0 0 0 0.180392 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9584_24092"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_9584_24092",
    result: "effect2_dropShadow_9584_24092"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_9584_24092",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_9584_24092",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-17 -16.5) rotate(44.1186) scale(45.9674)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEE0EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9584_24092"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 40,
    height: 40,
    rx: 10,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckMail);
export default __webpack_public_path__ + "static/media/checkMail.14b80b2fae1039cb7659d659306de2bc.svg";
export { ForwardRef as ReactComponent };